// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__wr5Ta","name":"ConsentHeader_name__2IIZl","birthday":"ConsentHeader_birthday__Fr3_8","skeleton":"ConsentHeader_skeleton__3oag1"};